export enum Images {
    MicrosoftTransparent = '/assets/img/brands/microsoft-transparent.png',
    GoogleTransparent = '/assets/img/brands/google-transparent.png',
}
